import { Injectable } from '@angular/core';
import { AppConfigService } from '@symphony-solo/domain/company-group/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { LocationPropTypes } from '../models';

@Injectable()
export class ChooseLocationService {
  public locationPropTypesIndex = [];
  protected path = 'orderlocations';

  constructor(private httpService: HttpService, private appConfigService: AppConfigService) {}

  public getChooseLocation(): Observable<void> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if (this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makeGet<void>(this.path, null, null, { CompanyGuid: companyGUID });
  }

  public getLocationTimeslots(body: any): Observable<void> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if (this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makePost<void, void>('timeslots', body, null, { CompanyGuid: companyGUID });
  }

  public getLocationMenus(body: any): Observable<void> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if (this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makePost<void, void>('menus', body, null, { CompanyGuid: companyGUID });
  }

  public getDeliveryLocation(locationID: any): Observable<void> {
    let companyGUID = this.appConfigService.config?.companyGuid;
    if (this.appConfigService.getCompanyGroup) {
      companyGUID = this.appConfigService.getCompanyGroup?.companyGuid;
    }
    return this.httpService.makePost<void, void>('deliverylocations', locationID, null, { CompanyGuid: companyGUID });
  }

  public setLocationPropTypesIndex(): void {
    this.locationPropTypesIndex[LocationPropTypes.PaymentMerchant] = { type: 'number', value: '0' };
    this.locationPropTypesIndex[LocationPropTypes.DisplayMenu] = { type: 'boolean', value: 'False' };
    this.locationPropTypesIndex[LocationPropTypes.MeetingRoom] = { type: 'boolean', value: 'False' };
    this.locationPropTypesIndex[LocationPropTypes.MinimumOrderSpend] = { type: 'number', value: '0' };
    this.locationPropTypesIndex[LocationPropTypes.DeliveryOnly] = { type: 'boolean', value: 'False' };
  }
}
